// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const TransportProtocolSchema = z.enum(['TCP','UDP','SCTP','OTHER'] as const);

export type TransportProtocolType = `${z.infer<typeof TransportProtocolSchema>}`

export default TransportProtocolSchema;
